/* PastéBCN — Collection
   Web Component <pb-collection> que solo se ocupa de la animación
   de entrada del grid (IntersectionObserver, stagger por --pb-card-index).
   El toggle envío/recogida se ha eliminado: el método de entrega se
   resuelve en el carrito. */

if (!customElements.get('pb-collection')) {
  class PbCollection extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this._observer.disconnect();
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -10% 0px' }
      );
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  customElements.define('pb-collection', PbCollection);
}
